import React from "react";
import UsageHistory from "../modules/UsageHistory/UsageHistory";

export default function UsageHistoryPage() {
  return <UsageHistory />;
}
